import ApiClient from './ApiClient'

export default class EnruiryService {

  constructor() {
      this.apiClient = new ApiClient()
  }

  connectWithStripe() {
    return this.apiClient.createAuthed().get('stripe')
  }

  checkAccountStatus() {
    return this.apiClient.createAuthed().get('stripe/check-account-status')
  }

  preparePayment(payload) {
    return this.apiClient.create().post('stripe/create-payment', payload)
  }

  generateAccountLink() {
    return this.apiClient.createAuthed().get('stripe/generate-account-link')
  }

}